import {createStyles, makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core/styles';
import * as colors from 'assets/theme/colors';

const MenuItemStyles = makeStyles((theme: Theme) =>
    createStyles({
        menuItem: {
            color: colors.neutrals.A10,
            flexDirection: 'row',
            flexGrow: 1,
            opacity: 0.7,
            fontWeight: 'normal',
            fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
            backgroundColor: `${colors.primary.A00} !important`,
            '&.Mui-selected': {
                opacity: 1,
                backgroundColor: `${colors.primary.A00} !important`,
                '&:hover': {
                    backgroundColor: `${colors.primary.A00} !important`,
                },
            },
        },
        menuIcon: {
            marginRight: 8,
            minWidth: 24,
            fill: colors.neutrals.A10,
            backgroundColor: `${colors.primary.A00} !important`,
        },
        menuListNested: {
            paddingLeft: theme.spacing(3),
            color: colors.neutrals.A10,
            fontWeight: 'normal',
            fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
        },
        menuItemNested: {
            paddingLeft: theme.spacing(8),
            color: colors.neutrals.A10,
            fontWeight: 'lighter',
            fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
            borderLeft: `solid 2px ${colors.primary.A20}`,
            opacity: 0.85,
            backgroundColor: `${colors.primary.A00} !important`,
        },
        menuItemSubmodule: {
            paddingLeft: theme.spacing(8),
            color: `${colors.neutrals.A10} !important`,
            fontWeight: 'normal',
            fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
            borderLeft: `solid 2px ${colors.primary.A20}`,
            opacity: 0.6,
            backgroundColor: `${colors.primary.A00} !important`,
        },
        menuItemSelected: {
            paddingLeft: theme.spacing(8),
            color: colors.neutrals.A10,
            flexDirection: 'row',
            flexGrow: 1,
            opacity: 1,
            fontWeight: 'bold',
            fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
            borderLeft: `solid 2px ${colors.primary.A20}`,
            backgroundColor: `${colors.primary.A00} !important`,
        },
    })
);

export default MenuItemStyles;
